import {
  DocumentReference,
  INamedDocument,
  ISoftDelete,
  ITimestampRange,
  Timestamp,
  TypeGuard,
} from '@principle-theorem/shared';
import { IStaffer } from '../staffer/staffer';
import {
  ICustomReport,
  ICustomReportChartSection,
  ICustomReportColumn,
  ICustomReportFilter,
} from './custom-report';
import { IMarketingCampaignRun } from '../marketing/campaign-run';
import { IQueryScopeRequests } from './query-scopes';

export enum CustomReportCollection {
  ReportRuns = 'reportRuns',
}

export enum ReportRunStatus {
  Pending = 'pending',
  Running = 'running',
  Complete = 'complete',
  Failed = 'failed',
}

export enum ReportRunSource {
  Interactive = 'interactive',
  CampaignRun = 'campaignRun',
}

export const REPORT_RUN_RETENTION_DAYS = 30;

export interface IReportRunSnapshot {
  filters?: ICustomReportFilter[];
  columns?: ICustomReportColumn[];
  chartSections?: ICustomReportChartSection[];
  queryScopes?: IQueryScopeRequests;
  filterDate?: Timestamp;
  filterDateRange?: ITimestampRange;
}

export interface IReportRunResult {
  storageUrl?: string;
  resultCount?: number;
  completedAt?: Timestamp;
}

export interface IReportRun extends ISoftDelete {
  status: ReportRunStatus;
  runAt: Timestamp;
  expiresAt?: Timestamp;
  archivedAt?: Timestamp;
  runBy?: INamedDocument<IStaffer>;
  pinned: boolean;
  source: ReportRunSource;
  customReportRef?: DocumentReference<ICustomReport>;
  campaignRunRef?: DocumentReference<IMarketingCampaignRun>;
  reportSnapshot?: IReportRunSnapshot;
  result?: IReportRunResult;
}

export const isReportRunStatus = TypeGuard.enumValue(ReportRunStatus);
export const isReportRunSource = TypeGuard.enumValue(ReportRunSource);
